import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ActionsBox = ({ hasLinks, redirections, headText }) => (
  <S.ActionsContainer>
    <S.ActionsHead>{headText}</S.ActionsHead>
    {hasLinks
      ? redirections.map(({ route, label }) => (
        <S.ActionsLink key={label} to={route}>
            {label}
          </S.ActionsLink>
        ))
      : redirections.map(({ onClick, label, disabled }) => (
        <S.ActionsButton
            disabled={disabled || false}
            key={label}
            onClick={onClick}
          >
            {label}
          </S.ActionsButton>
        ))}
  </S.ActionsContainer>
);

export default ActionsBox;

ActionsBox.defaultProps = {
  hasLinks: true,
  redirections: [],
};

ActionsBox.propTypes = {
  hasLinks: PropTypes.bool,
  redirections: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      route: PropTypes.string,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
    }),
  ),
  headText: PropTypes.string.isRequired,
};
